import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import format from 'react-format-props';
import { compose } from 'redux';
import { Tooltip } from '@fiverr-private/fit';
import * as I18n from '../../lib/hoc';
import './style.scss';

function ButtonToggleRead({ isRead, toggleRead, i18n }) {
    const buttonClass = classNames('toggle-read', { read: isRead });
    const hintText = i18n.t(`realtime_notifications.notifications_drawer.mark_${isRead ? 'unread' : 'read'}`);

    const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleRead();
    };

    return (
        <Tooltip
            content={hintText}
            position={Tooltip.POSITIONS.LEFT}
            containerClassName="toggle-read-tooltip-container"
        >
            <button className={buttonClass} onClick={onClick} />
        </Tooltip>
    );
}

ButtonToggleRead.propTypes = {
    isRead: propTypes.bool,
    toggleRead: propTypes.func,
    i18n: propTypes.shape({
        t: propTypes.func,
    }),
};

export default compose(
    I18n.connect,
    format((props) => ({
        ...props,
    }))
)(ButtonToggleRead);
